import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bot1',
  templateUrl: './bot1.component.html',
  styleUrls: ['./bot1.component.css']
})
export class Bot1Component implements OnInit {
  @Input() colorbot: string;

  constructor() { }

  ngOnInit() {
    this.colorbot ="#9999997c"
  }

}
